import styled from "styled-components"
import IcAddRed from "../assets/images/ic_add_red.svg"
import IcAddBlue from "../assets/images/ic_add_blue.svg"
import IcAddGreen from "../assets/images/ic_add_green.svg"
import IcAddWhite from "../assets/images/ic_add_white.svg"
import PlayerCard from "./PlayerCard"
import { useSquad } from "../contexts/SquadContext"
import DeleteImg from "../assets/images/bg_delete.svg"
import ComposeImg from "../assets/images/ic_compose.svg"
import MaximizeImg from "../assets/images/ic_maximize.svg"
import FaceOnImg from "../assets/images/ic_faceon.svg"
import { useState } from "react"
import Enforce0 from "../assets/images/ic_enforce_0.svg"
import Enforce1 from "../assets/images/ic_enforce_1.svg"
import Enforce2 from "../assets/images/ic_enforce_2.svg"
import Enforce3 from "../assets/images/ic_enforce_3.svg"
import Enforce4 from "../assets/images/ic_enforce_4.svg"
import Enforce5 from "../assets/images/ic_enforce_5.svg"
import Enforce6 from "../assets/images/ic_enforce_6.svg"
import Enforce7 from "../assets/images/ic_enforce_7.svg"
import Enforce8 from "../assets/images/ic_enforce_8.svg"
import Enforce9 from "../assets/images/ic_enforce_9.svg"
import Enforce10 from "../assets/images/ic_enforce_10.svg"
import Awaken1 from "../assets/images/ic_awaken_1.svg"
import Awaken2 from "../assets/images/ic_awaken_2.svg"
import Awaken3 from "../assets/images/ic_awaken_3.svg"
import Awaken4 from "../assets/images/ic_awaken_4.svg"
import Awaken5 from "../assets/images/ic_awaken_5.svg"
import Awaken6 from "../assets/images/ic_awaken_6.svg"
import Awaken7 from "../assets/images/ic_awaken_7.svg"
import Awaken8 from "../assets/images/ic_awaken_8.svg"
import Awaken9 from "../assets/images/ic_awaken_9.svg"
import LevelPopup from "./LevelPopup"
import { useDetailModal, useSearchModal, useFaceOnUploadModal } from "../contexts/ModalContext"
import { isAwakenAvailable } from "../utils/calculateEnforcedStates"
import { getMaxTrainStates } from "../utils/calculateMaxTrainLevel"
import { getMaxPositionTrainAdditionalStates, getMaxPositionTrainStates, getMaxSpecialTrainStates } from "../utils/calculatePositionTrainStates"
import FaceOnSelectPopup from "./FaceOnSelectPopup"
import { getPlayerFaceOns } from "../api/getTopImagesByPlayerIds"
import { incrementImageUsage } from "../api/uploadPlayerImage"

const CardHolder = styled.div`
    display: flex;
    flex-direction: column;
    width: 6.25rem; 
    height: 9.0625rem; 
    background-image: linear-gradient(
        -40deg,
        #D3D3D3 44%,
        #EFF2F4 56%
    );
    border-radius: 0 0.625rem 0 0.625rem; 
    border: #87898A solid 0.125rem; 
    justify-content: center;
    align-items: center;
    z-index: 2;
`

const BatterCardHolder = styled(CardHolder)`
    position: absolute;
`
const LfCardHolder = styled.div`
    position: absolute;
    top: 10rem;
    left: 8.125rem;
`

const RfCardHolder = styled.div`
    position: absolute;
    top: 10rem;
    right: 8.125rem;
`

const CfCardHolder = styled.div`
    position: absolute;
    top: 6rem;
    align-self: center;
`

const SsCardHolder = styled.div`
    position: absolute;
    left: 16.75rem;
    top: 17.5rem;
`

const P2bCardHolder = styled.div`
    position: absolute;
    right: 16.75rem;
    top: 17.5rem;
`

const P3bCardHolder = styled.div`
    position: absolute;
    left: 6.875rem;
    top: 24.25rem;
`

const P1bCardHolder = styled.div`
    position: absolute;
    right: 6.875rem;
    top: 24.25rem;
`

const CCardHolder = styled.div`
    position: absolute;
    bottom: 14.5rem;
    align-self: center;
`

const DhCardHolder = styled.div`
    position: absolute;
    bottom: 14.5rem;
    right: 14.75rem;
`

const BlankCardHolder = styled.div`

`

const HoverdBox = styled.div`
    width: 6.25rem; 
    height: 9.0625rem; 
    position: absolute;
    top: 0.125rem;
    left: 0.125rem;
    border-radius: 0 0.5rem 0 0.5rem; 
    z-index: 3;
    background-color: rgba(169, 57, 255, 0.25);
`

const DeleteButton = styled.img`
    width: 2.5rem;
    position: absolute;
    bottom: -0.75rem;       
    left: -0.75rem;

    filter: 
    drop-shadow(0rem 0rem 0.125rem rgba(0, 0, 0, 0.5));
    z-index: 4;
    &:hover {
        cursor: pointer;
    }
`

const ComposeButton = styled.img`
    width: 2.5rem;
    position: absolute;
    top: -0.75rem;
    right: -0.75rem;

    filter:
    drop-shadow(0rem 0rem 0.125rem rgba(0, 0, 0, 0.5));
    z-index: 4;
    &:hover {
        cursor: pointer;
    }
`

const MaximizeButton = styled.img`
    width: 2.5rem;
    position: absolute;
    top: -0.75rem;       
    left: -0.75rem;

    filter: 
    drop-shadow(0rem 0rem 0.125rem rgba(0, 0, 0, 0.5));
    z-index: 4;
    &:hover {
        cursor: pointer;
    }
`


const PositionMap = {
    'LF': LfCardHolder,
    'CF': CfCardHolder,
    'RF': RfCardHolder,
    'SS': SsCardHolder,
    '2B': P2bCardHolder,
    '1B': P1bCardHolder,
    '3B': P3bCardHolder,
    'C': CCardHolder,
    'DH': DhCardHolder,
    'SUB1': BlankCardHolder,
    'SUB2': BlankCardHolder,
    'SUB3': BlankCardHolder,
    'SUB4': BlankCardHolder,
    'SUB5': BlankCardHolder,
    'SUB6': BlankCardHolder,
    'SP1': BlankCardHolder,
    'SP2': BlankCardHolder,
    'SP3': BlankCardHolder,
    'SP4': BlankCardHolder,
    'SP5': BlankCardHolder,
    'RP1': BlankCardHolder,
    'RP2': BlankCardHolder,
    'RP3': BlankCardHolder,
    'RP4': BlankCardHolder,
    'RP5': BlankCardHolder,
    'RP6': BlankCardHolder,
    'CP': BlankCardHolder,
    '1번': BlankCardHolder,
    '2번': BlankCardHolder,
    '3번': BlankCardHolder,
    '4번': BlankCardHolder,
    '5번': BlankCardHolder,
    '6번': BlankCardHolder,
    '7번': BlankCardHolder,
    '8번': BlankCardHolder,
    '9번': BlankCardHolder,
}

const ColorIconMap = {
    'LF': IcAddRed,
    'CF': IcAddRed,
    'RF': IcAddRed,
    'SS': IcAddBlue,
    '2B': IcAddBlue,
    '1B': IcAddBlue,
    '3B': IcAddBlue,
    'C': IcAddBlue,
    'DH': IcAddGreen,
    'SUB1': IcAddWhite,
    'SUB2': IcAddWhite,
    'SUB3': IcAddWhite,
    'SUB4': IcAddWhite,
    'SUB5': IcAddWhite,
    'SUB6': IcAddWhite,
    'SP1': IcAddRed,
    'SP2': IcAddRed,
    'SP3': IcAddRed,
    'SP4': IcAddRed,
    'SP5': IcAddRed,
    'RP1': IcAddBlue,
    'RP2': IcAddBlue,
    'RP3': IcAddBlue,
    'RP4': IcAddBlue,
    'RP5': IcAddBlue,
    'RP6': IcAddBlue,
    'CP': IcAddGreen,
    '1번': IcAddRed,
    '2번': IcAddRed,
    '3번': IcAddBlue,
    '4번': IcAddBlue,
    '5번': IcAddBlue,
    '6번': IcAddGreen,
    '7번': IcAddGreen,
    '8번': IcAddGreen,
    '9번': IcAddGreen,
}

const EnforceMap = {
    0: Enforce0,
    1: Enforce1,
    2: Enforce2,
    3: Enforce3,
    4: Enforce4,
    5: Enforce5,
    6: Enforce6,
    7: Enforce7,
    8: Enforce8,
    9: Enforce9,
    10: Enforce10,
}

const AwakenMap = {
    1: Awaken1,
    2: Awaken2,
    3: Awaken3,
    4: Awaken4,
    5: Awaken5,
    6: Awaken6,
    7: Awaken7,
    8: Awaken8,
    9: Awaken9,
}

const PositionDisplay = styled.div`
    font-size: 1.125rem; 
    font-family: 'Pretendard Variable';
    color: black;
    font-weight: 500;
    margin-bottom: 0.625rem;
`

const AddButton = styled.img`
    width: 4.375rem; 
    height: 4.375rem;
    cursor: pointer;
`

const AddButtonForDisplay = styled.img`
    width: 4.375rem; 
    height: 4.375rem;
`

const LevelButton = styled.img`
    position: absolute;
    right: -0.75rem;
    bottom: -0.75rem;

    filter:
    drop-shadow(0rem 0rem 0.125rem rgba(0, 0, 0, 0.5));
    z-index: 4;
    cursor: pointer;
`

const EnforceLevelButton = styled(LevelButton)`
    width: 2rem;
`
const AwakenLevelButton = styled(LevelButton)`
    width: 2.75rem;
`
const LevelPopupContainer = styled.div`
    position: absolute;
    bottom: 2rem;
    right: -0.75rem;
    z-index: 10;
`

const FaceOnButton = styled.img`
    width: 2.5rem;
    position: absolute;
    top: -0.75rem;
    left: 50%;
    transform: translateX(-50%);

    filter:
    drop-shadow(0rem 0rem 0.125rem rgba(0, 0, 0, 0.5));
    z-index: 4;
    &:hover {
        cursor: pointer;
    }
`

export default function PlayerCardHolder({position, player, isForDisplay=false}) {

    const SelectedIcon = ColorIconMap[position] || IcAddWhite;

    const SelectedCardHolder = PositionMap[position] || CfCardHolder;

    const {playerInfos, addPlayer, removePlayer} = useSquad();
    
    const [isHovered, setIsHovered] = useState(false);

    const [levelPopupVisible, setLevelPopupVisible] = useState(false);

    const {isSearchModalOpen, openSearchModal, closeSearchModal} = useSearchModal();

    const { isDetailModalOpen, openDetailModal, closeDetailModal } = useDetailModal();
    const { openFaceOnUploadModal } = useFaceOnUploadModal();

    const [faceOnList, setFaceOnList] = useState([]);
    const [isFaceOnListLoading, setIsFaceOnListLoading] = useState(false);
    const [isFaceOnSelectPopupOpen, setIsFaceOnSelectPopupOpen] = useState(false);
    const [isSelectingFaceOn, setIsSelectingFaceOn] = useState(false);

    const onDeleteButtonClick = () => {
        removePlayer(position);
    }

    const onLevelButtonClick = () => {
        setLevelPopupVisible(true);
    }

    const onPlaceHolderClick = (position) => {
        openSearchModal(position);
    }

    const onLevelSelected = (levelInfo) => {
        addPlayer(position, {
            ...player,
            level: levelInfo.level,
            isAwaken: levelInfo.isAwaken
        });
        setLevelPopupVisible(false);
        setIsHovered(false);
    }

    const CurrentLevelSrc = player ? (player.isAwaken ? AwakenMap[player.level] : EnforceMap[player.level]) : null;

    const SelectedLevelButton = player ? (player.isAwaken ? AwakenLevelButton : EnforceLevelButton) : null;

    const onComposeButtonClicked = () => {
        openDetailModal(position);
    }

    const onMaximizeButtonClick = () => {
        const isPlayerAwakenAvailable = isAwakenAvailable(player);
        const maxLevel = isPlayerAwakenAvailable ? 9 : 10;
        const maxTrainStates = getMaxTrainStates(player);
        const maxPositionTrainStates = getMaxPositionTrainStates(player, position);
        const maxPositionTrainAdditionalStates = getMaxPositionTrainAdditionalStates(player, position);
        const maxSpecialTrainStates = getMaxSpecialTrainStates(player);

        addPlayer(position, {
            ...player,
            level: maxLevel,
            isAwaken: isPlayerAwakenAvailable,
            trainedStates: maxTrainStates,
            positionTrainedStates: maxPositionTrainStates,
            positionTrainedAdditionalStates: maxPositionTrainAdditionalStates,
            specialTrainedStates: maxSpecialTrainStates,
        });
        setIsHovered(false);
    }

    const onFaceOnSelected = async (selectedFaceOn) => {
        if (isSelectingFaceOn) return; // 중복 선택 방지

        setIsSelectingFaceOn(true);
        try {
            // 이미지 선택 저장
            addPlayer(position, {
                ...player,
                faceOn: {
                    id: selectedFaceOn.id,
                    url: selectedFaceOn.imageUrl
                }
            });

            // 사용량 증가
            await incrementImageUsage(selectedFaceOn.id);

            setIsFaceOnSelectPopupOpen(false);
        } catch (error) {
            console.error('이미지 선택 중 오류:', error);
            alert('이미지 선택 중 오류가 발생했습니다. 다시 시도해주세요.');
        } finally {
            setIsSelectingFaceOn(false);
        }
    }

    const onFaceOnButtonClick = async () => {
        if (!isFaceOnSelectPopupOpen) {
            setIsFaceOnListLoading(true);
            try {
                const faceOns = await getPlayerFaceOns(player.playerName, player.team);
                const formattedList = faceOns.map(item => ({
                    id: item.id,
                    imageUrl: item.image_url,
                    uploaderId: item.uploader_id
                }));
                setFaceOnList(formattedList);
            } catch (error) {
                console.error('이미지 목록 로드 실패:', error);
                alert('이미지 목록을 불러올 수 없습니다.');
                setIsFaceOnListLoading(false);
                return;
            } finally {
                setIsFaceOnListLoading(false);
            }
        }
        setIsFaceOnSelectPopupOpen(true);
    }

    const onAddClick = () => {
        setIsFaceOnSelectPopupOpen(false);
        openDetailModal(position);
        openFaceOnUploadModal();
    }

    const isPlayerNotDummy = player && player.team !== "더미";

    return (
        
        <SelectedCardHolder
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >

            {player ? 
            <div style={{position: 'relative'}}>
                <PlayerCard 
                    player={player}
                    isForDisplay={false}
                />
                {isHovered && <DeleteButton onClick={onDeleteButtonClick} src={DeleteImg}></DeleteButton>}
                {isHovered && isPlayerNotDummy && <ComposeButton onClick={onComposeButtonClicked} src={ComposeImg}></ComposeButton>}
                {isHovered && isPlayerNotDummy && <MaximizeButton onClick={onMaximizeButtonClick} src={MaximizeImg}></MaximizeButton>}
                {isHovered && <HoverdBox></HoverdBox>}
                {isHovered && isPlayerNotDummy && <SelectedLevelButton onClick={onLevelButtonClick} src={CurrentLevelSrc}></SelectedLevelButton>}

                <LevelPopupContainer>
                    {levelPopupVisible && <LevelPopup
                        isVisible={levelPopupVisible}
                        onClose={() => setLevelPopupVisible(false)}
                        onLevelSelected={onLevelSelected}
                        isAllowAwaken={['임팩트', '시그니쳐', '국가대표', '골든글러브'].includes(player.type)}
                    />}
                </LevelPopupContainer>

                {isHovered && isPlayerNotDummy && <FaceOnButton onClick={onFaceOnButtonClick} src={FaceOnImg}></FaceOnButton>}

                {isFaceOnSelectPopupOpen && <FaceOnSelectPopup
                    onSelect={onFaceOnSelected}
                    onClose={() => setIsFaceOnSelectPopupOpen(false)}
                    defaultFaceOnId={player.faceOn?.id}
                    faceOnList={faceOnList}
                    isLoading={isSelectingFaceOn}
                    onAddClick={onAddClick}
                />}
            </div>
            :
            <CardHolder>
                <PositionDisplay>
                    {position}
                </PositionDisplay>

                {isForDisplay ? <AddButtonForDisplay src={SelectedIcon}></AddButtonForDisplay>
                :
                <AddButton onClick={() => {onPlaceHolderClick(position)}} src={SelectedIcon}></AddButton>}
            </CardHolder>}
            
        </SelectedCardHolder>
    )
}